import { ApiResponse, ImageGenerationApi, ImageGenerationRequest, ImageGenerationStartResponse } from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { ImageGenerationApiService } from "../ApiServices/ImageGenerationApiService";
import GenericService from "../GenericService";

export class ImageGenerationService extends GenericService<ImageGenerationApi, ImageGenerationApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, ImageGenerationApi, ImageGenerationApiService);
  }

  public async cancelImageGeneration(processId: string): Promise<string> {
    return this.apiService.cancelImageGenerationPost({ processId });
  }

  public async generateImages(imageGenerationRequest: ImageGenerationRequest): Promise<ImageGenerationStartResponse> {
    return this.apiService.imageGenerationOnPost({
      imageGenerationRequest,
    });
  }

  public async getThumbnailsByImageId(imageIds: string[]): Promise<Blob> {
    return this.apiService.imageGenerationGetImagesByIds({ imageIds: imageIds });
  }

  public async getImagesForDownload(imageIds: string[]): Promise<ApiResponse<Blob>> {
    return await this.apiService.imageGenerationGetImagesByIdsRaw({ imageIds: imageIds });
  }
}
